// Module
var code = `<table class="dynamic-list__table table"
       ng-table-dynamic="\$ctrl.tableConfig with \$ctrl.columns"
       ng-class="{'dynamic-list__table-error': \$ctrl.listType === 'ERROR', 'table--generate-row-ids': \$ctrl.generateRowIds}"
>
  <tbody class="tbody">
  <tr ng-repeat="row in \$data" class="dynamic-list__row">
    <td ng-repeat="col in \$columns">
      <span ng-if="col.field">{{\$ctrl.getValue(row, col.field)}}</span>

      <div class="summary-actions summary-actions--row" ng-if="col.actions && col.actions.length > 0">
        <div ng-repeat="action in col.actions">
          <a ng-if="action.type == 'LINK' && \$ctrl.hasAccess(row, action) && \$ctrl.getValue(row, action.field)"
             class="dynamic-list__column-edit btn {{ action.style ? action.style : 'btn-warning' }}"
             ng-href="{{\$ctrl.getValue(row, action.field)}}">
            {{ action.label }}
          </a>

          <button ng-if="action.type == 'BUTTON' && \$ctrl.hasAccess(row, action) && \$ctrl.getValue(row, action.field)"
              class="dynamic-list__column-edit btn {{ action.style ? action.style : 'btn-primary' }}"
              ng-click="\$ctrl.getValue(row, action.field)()"
              >
            {{ action.label }}
          </button>
        </div>
      </div>
    </td>
  </tr>
  </tbody>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/dynamic-list/dynamic-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;